import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { SharedStripeSnackbarComponent } from './stripe-snackbar.component';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [SharedStripeSnackbarComponent],
  imports: [
    CommonModule,
    RouterModule,
    MatIconModule,
    TranslateModule.forChild(),
  ],
  exports: [SharedStripeSnackbarComponent],
})
export class StripeSnackbarSharedModule {}
